import React from "react";
import { Link } from "react-router-dom";
import { OFFICES, CONTACT, LOGO_URL } from "../data/content";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      style={{ background: "var(--color-primary)", color: "var(--color-on-primary)" }}
    >
      <div
        className="di-container"
        style={{ paddingTop: "var(--space-80)", paddingBottom: "var(--space-48)" }}
      >
        {/* Columns: Navigate / Offices (2 sub-cols) / Get in Touch + logo */}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-3">
            <div
              className="label-sm mb-5"
              style={{ color: "rgba(249,249,248,0.45)" }}
            >
              Navigate
            </div>
            <ul className="space-y-3 body-sm">
              <li>
                <Link
                  data-testid="footer-link-services"
                  to="/services"
                  style={{ color: "rgba(249,249,248,0.85)" }}
                >
                  What We Do
                </Link>
              </li>
              <li>
                <Link
                  data-testid="footer-link-work"
                  to="/work"
                  style={{ color: "rgba(249,249,248,0.85)" }}
                >
                  Our Work
                </Link>
              </li>
              <li>
                <Link
                  data-testid="footer-link-about"
                  to="/about"
                  style={{ color: "rgba(249,249,248,0.85)" }}
                >
                  Our Story
                </Link>
              </li>
              <li>
                <Link
                  data-testid="footer-link-investors"
                  to="/investors"
                  style={{ color: "rgba(249,249,248,0.85)" }}
                >
                  Investors
                </Link>
              </li>
              <li>
                <Link
                  data-testid="footer-link-contact"
                  to="/contact"
                  style={{ color: "rgba(249,249,248,0.85)" }}
                >
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          <div className="md:col-span-5">
            <div
              className="label-sm mb-5"
              style={{ color: "rgba(249,249,248,0.45)" }}
            >
              Offices
            </div>
            <ul
              className="grid grid-cols-2 gap-x-6 gap-y-3 body-sm"
              style={{ color: "rgba(249,249,248,0.85)", listStyle: "none", padding: 0 }}
            >
              {OFFICES.map((o) => (
                <li key={o.city} style={{ color: "rgba(249,249,248,0.85)" }}>
                  {o.city}
                  {o.note ? (
                    <span style={{ color: "rgba(249,249,248,0.45)" }}>
                      {" "}
                      · {o.note}
                    </span>
                  ) : null}
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <div
              className="label-sm mb-5"
              style={{ color: "rgba(249,249,248,0.45)" }}
            >
              Get in Touch
            </div>
            <p
              className="body-sm leading-relaxed"
              style={{ color: "rgba(249,249,248,0.75)" }}
            >
              {CONTACT.address}
            </p>
            <div className="mt-4 space-y-2 body-sm">
              <div>
                <a
                  data-testid="footer-phone"
                  href={`tel:${CONTACT.phone}`}
                  style={{ color: "rgba(249,249,248,0.85)" }}
                >
                  {CONTACT.phone}
                </a>
              </div>
              <div>
                <a
                  data-testid="footer-email"
                  href={`mailto:${CONTACT.email}`}
                  style={{ color: "rgba(249,249,248,0.85)" }}
                >
                  {CONTACT.email}
                </a>
              </div>
            </div>
            <div className="mt-8">
              <img
                src={LOGO_URL}
                alt="DesignIndya"
                data-testid="footer-logo"
                style={{ height: 26, filter: "brightness(0) invert(1)", opacity: 0.75 }}
              />
            </div>
          </div>
        </div>

        <div
          className="mt-16 pt-8 flex flex-col md:flex-row items-center justify-between gap-4 label-sm"
          style={{
            borderTop: "1px solid rgba(249,249,248,0.08)",
            color: "rgba(249,249,248,0.4)",
          }}
        >
          <div className="text-center md:text-left">
            © {new Date().getFullYear()} DesignIndya Advertising Limited. All rights reserved.
          </div>
          <div className="flex gap-6">
            <span className="cursor-pointer hover:opacity-80">Privacy</span>
            <span className="cursor-pointer hover:opacity-80">Terms</span>
            <span className="cursor-pointer hover:opacity-80">Cookies</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
